import { render, staticRenderFns } from "./TModern.vue?vue&type=template&id=cc910d42&scoped=true&"
import script from "./TModern.vue?vue&type=script&lang=js&"
export * from "./TModern.vue?vue&type=script&lang=js&"
import style0 from "./TModern.vue?vue&type=style&index=0&id=cc910d42&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc910d42",
  null
  
)

export default component.exports